export default __webpack_public_path__ + "static/media/IMG_5589.a9728c02.jpg";